import { displaySolution } from "../Results/transformFt";
import { inputResult } from "../Submit/SaveAnswer";
import { addSelfRatingButtons } from "./RatingButtons";


export function transformFtToSelf(input:JQuery, results:inputResult, points:number, possible:number){
    
    
    input.prop('disabled', true);
    input.val(results.answer);

    input.css('height', '100%');
    input.css('white-space', 'pre-wrap');


    const parent = input.parent();


    // Nur wenn ausgefüllt
    if (results.answer != ''){
        let html = displaySolution(results.correct)
        const taskId = parseInt(input.attr('data-id'))
        html += addSelfRatingButtons(taskId)
        parent.after(html)
    }

}

export function deescapeJsonString(text:string):string{
    const replaceOne = '|+|';
    const replaceTwo = '|-|';

    text = text.replaceAll(replaceOne, "'")
    text = text.replaceAll(replaceTwo, '"');

    return text;
}